<template>
  <div class="page">
    <!-- 头部 -->
    <AboutHeader></AboutHeader>
    <!-- 关于博雅数字 -->
    <div class="content">
      <img src="../../assets/images/about.png" alt="">
      <p class="desc">博雅数字（辽宁）经济发展有限公司（以下简称：博雅数字）是一家致力于为政府、金融、教育、交通、农业、互联网/运营商等行业客户提供综合性IT解决方案和数据服务的技术服务商，也是一家全价值链信用生态系统的创造者。公司于2019年9 月在中国（辽宁）自由贸易试验区沈阳片区注册成立，注册资金人民币3932.5万元。 博雅数字探索研究大数据、云计算、物联网、人工智能、区块链等核心技术在行业中的应用模式，精心打造目标行业的数字化解决方案，为客户提供科学、规范、专业、创新的一体化解决方案和数据相关服务。 博雅数字以“项目合作—研发+应用推广—培育产业集群”的思路，构建“企业为主体、市场为导向、产学研用结合”的大数据技术创新体系。在深度打造“三位一体”深度联动的科研创新和产业转化平台的同时，充分发挥高校、科研机构和政府的技术与资源优势，为行业用户提供优质、便捷和有效的数据相关服务，为特色数字生态环境的打造提供技术支持。 公司基于自身优势，整合政府、高校、科研机构和企业资源，充分挖掘企业的信用数据，探索构建与国际通行信用标准相对接的信用指标体系，打造集大数据、云计算、区块链、人工智能为一体的信用生态体系。实现生态体系内全产业链合作伙伴的协同创新，共同为产业升级与发展，创造增值效应。</p>
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>
<script>
import Footer from "@/components/page/Footer.vue";
import AboutHeader from "@/components/page/AboutHeader.vue";
export default {
  components: {
    Footer,
    AboutHeader
  },
  data() {
    return {
      
    }
  },
  created() {
    
  },
  methods: {
    
  },
}
</script>
<style scoped>
.page .content {
  width: 100%;
  margin-top: 150px;
  padding: 0 32px;
  box-sizing: border-box;
  margin-bottom: 100px;
}
.page .content img {
  width: 686px;
  height: 380px;
  display: block;
}
.page .content p {
  margin-top: 60px;
  text-align: justify;
  font-size: 24px;
  color: #666666;
  line-height: 50px;
}


</style>